import { render, staticRenderFns } from "./EditParcel.vue?vue&type=template&id=2615afd4&scoped=true"
import script from "./EditParcel.vue?vue&type=script&lang=js"
export * from "./EditParcel.vue?vue&type=script&lang=js"
import style0 from "./EditParcel.vue?vue&type=style&index=0&id=2615afd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2615afd4",
  null
  
)

export default component.exports